export default __webpack_public_path__ + "static/media/close-icon.99dc9a03.svg";